export default "__VITE_ASSET__debcb81f__"